import type { UserTypeOption } from './enquiryConfig';
import { SelectableCard } from './SelectableCard';
import { StepHeading } from './StepText';

export type UserType =
    | 'Homeowner'
    | 'Developer'
    | 'Business Owner'
    | 'Industry Professional';

interface Step1UserTypeProps {
    title: string;
    options: UserTypeOption[];
    value: UserType | null;
    onSelect: (type: UserType) => void;
}

export const Step1UserType = ({
    title,
    options,
    value,
    onSelect,
}: Step1UserTypeProps) => {
    return (
        <div className="flex flex-col gap-[1.375rem]">
            <StepHeading>{title}</StepHeading>
            <ul className="flex flex-col gap-2">
                {options.map((option) => (
                    <li key={option.value}>
                        <SelectableCard
                            title={option.title}
                            subtitle={option.subtitle}
                            selected={value === option.value}
                            onClick={() => onSelect(option.value)}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};
